import { TabsLayout } from '@/layouts/TabsLayout'
import type { TabNavigationItem } from '@/components/Tabs/TabsNavigation'

const TAB_VISAO_GERAL: TabNavigationItem = {
  value: 'visao-geral',
  label: 'Visão Geral',
  icon: 'mdi:view-dashboard-outline',
  to: '/sou-afiliado',
}

const TAB_LINKS: TabNavigationItem = {
  value: 'links',
  label: 'Campanhas e Links',
  icon: 'mdi:link-variant',
  to: '/sou-afiliado/links',
}

const TAB_VENDAS: TabNavigationItem = {
  value: 'vendas',
  label: 'Minhas Vendas',
  icon: 'mdi:receipt-text-outline',
  to: '/sou-afiliado/vendas',
}

const TAB_SALDO: TabNavigationItem = {
  value: 'saldo',
  label: 'Saldo',
  icon: 'mdi:wallet-outline',
  to: '/sou-afiliado/saldo',
}

const TABS = [TAB_VISAO_GERAL, TAB_LINKS, TAB_VENDAS, TAB_SALDO] as const

export function SouAfiliadoTabsLayout() {
  return (
    <TabsLayout
      title="Sou Afiliado"
      subtitle="Acompanhe suas indicações, links e comissões"
      tabs={[...TABS]}
    />
  )
}
